import { render, staticRenderFns } from "./annexlist.vue?vue&type=template&id=d1881078&scoped=true&"
import script from "./annexlist.vue?vue&type=script&lang=js&"
export * from "./annexlist.vue?vue&type=script&lang=js&"
import style0 from "./annexlist.vue?vue&type=style&index=0&id=d1881078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1881078",
  null
  
)

export default component.exports